import Reveal from "./Reveal";

interface SectionIntroProps {
  eyebrow?: string;
  title: string;
  description?: string;
}

const SectionIntro = ({ eyebrow, title, description }: SectionIntroProps) => {
  return (
    <div className="mx-auto mb-14 max-w-2xl text-center">
      {eyebrow && (
        <Reveal>
          <div className="mb-3 flex items-center justify-center gap-2">
            <span className="h-3 w-[3px] bg-[var(--red)]" />
            <span className="text-[12px] font-semibold uppercase tracking-[0.14em] text-white/50">
              {eyebrow}
            </span>
          </div>
        </Reveal>
      )}
      <Reveal delay={80}>
        <h2 className="text-[28px] font-bold leading-tight tracking-tight text-white max-sm:text-[22px]">
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={160}>
          <p className="mt-4 text-[16px] leading-relaxed text-white/60 max-sm:text-[14px]">
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
};

export default SectionIntro;
